module.exports = __webpack_public_path__ + "static/media/loading_car.f356fabf.webp";